module.exports = __webpack_public_path__ + "static/img/ic_investigator_gifts.f7a50fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b122/ic_investigator_gifts.png
// module id = 1Skc
// module chunks = 0